import React from 'react'

function Consultant() {
  return (
    <div>Consultant</div>
  )
}

export default Consultant